<template>
  <v-row>
    <v-col>
      <v-row v-if="screen.logo_base64">
        <v-col>
          <v-img :src="'data:image/jpg;base64,'+screen.logo_base64" />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          class="text-center"
          cols="12"
        >
          <span :style="`color:${screen.text1.color};font-size:${screen.text1.size}px`"> {{ screen.text1.text }} </span>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          class="text-center"
          cols="12"
        >
          <span :style="`color:${screen.text2.color};font-size:${screen.text2.size}px`"> {{ screen.text2.text }} </span>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          offset="4"
          cols="4"
        >
          <v-btn
            width="100%"
            :style="`color: ${screen.buttons.text.color}; background-color: ${screen.buttons.background}`"
            @click="onReloadWindow"
          >
            Назад
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
import { configuration } from "@/views/loyalty/models/justpay-configuration.model"
import { setScreenBackground } from "@/views/loyalty/shared/modules/utilities"

export default {
  name: 'ConfigurationErrorScreen',
  props: {
    // configuration: {
    //   type: Object,
    //   default: configuration
    // },
    screen: {
      type: Object,
      default: configuration.interface_description.error_screen
    },
  },
  watch: {
    'screen.background' (newValue) {
      setScreenBackground(newValue)
    }
  },
  methods: {
    onReloadWindow () {
      window.location.reload()
    },
  }
}
</script>

<style scoped>

</style>
